import { useMutation, useQuery } from '@apollo/client';
import { ChevronLeftIcon } from '@chakra-ui/icons';
import {
    Box, Button,
    Divider,
    Flex,
    HStack,
    Heading,
    Link,
    Spinner,
    Stack,
    Text,
    useToast
} from "@chakra-ui/react";
import { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import ProfileFooter from "../../Components/Footer/ProfileFooter";
import { SHOW_INTEREST_IN_PROPERTY } from '../../Components/Graphql/Mutations';
import { GET_PROPERTY_BY_ID } from '../../Components/Graphql/Queries';
import ConfidentialReport from "../../Components/PropertyDetail/ConfidentialReport";
import Contact from "../../Components/PropertyDetail/Contact";
import Description from "../../Components/PropertyDetail/Description";
import InvestmentCard from "../../Components/PropertyDetail/InvestmentCard";
import InvestmentHighlight from "../../Components/PropertyDetail/InvestmentHighlight";
import PerformanceMetrics from "../../Components/PropertyDetail/PerformanceMetrics";
import PropertyDetailIntro from "../../Components/PropertyDetail/PropertyDetailIntro";
import SocialMediaIcn from "../../Components/PropertyDetail/SocialMediaIcn";
import Sponsor from "../../Components/PropertyDetail/Sponsor";
import CustomSpinner from '../../Components/Spinner/CustomSpinner';





const PropertyDetail = () => {
    const navigate = useNavigate();
    const toast = useToast();
    const { id } = useParams();
    console.log("Id param", id);
    const [investment, setInvestment] = useState(0);
    const [investmentError, setInvestmentError] = useState(null);
    const [propertyData, setPropertyData] = useState(null);
    const { loading, error, data } = useQuery(GET_PROPERTY_BY_ID, {
        variables: {
            propertyId: id,
        },
    });
    const scrollToSection = () => {
        const section = document.getElementById('documents');
        if (section) {
            section.scrollIntoView({
                behavior: 'smooth'
            });
        }
    };
    const [showInterestInPropertyMutation, showInterestResponse] = useMutation(SHOW_INTEREST_IN_PROPERTY);

    useEffect(() => {
        if (showInterestResponse.data !== undefined) {
            console.log("Response after showing interest in property: ", showInterestResponse.data);
						setInvestment(0);
						setInvestmentError(null);
            toast({
                title: 'Interest Expressed',
                description: 'Property has been added to your Interested Properties',
                status: 'success',
                duration: 4000,
                isClosable: true,
                position: 'bottom-left'
            });
        }

        if (showInterestResponse.error !== undefined) {
            console.log("Error from showing interest in property: ", showInterestResponse.error);
            toast({
                title: 'Error',
                description: 'An error occured while expressing interest in property',
                status: 'error',
                duration: 4000,
                isClosable: true,
                position: 'bottom-left'
            });
        }
    }, [
        showInterestResponse.data,
        showInterestResponse.loading,
        showInterestResponse.error
    ]);

    useEffect(() => {

        console.log("error:", error)
        console.log("loading:", loading)
        console.log("data:", data)

        if (data != undefined) {
            setPropertyData(data.getPropertyById);

        }
        if (error != undefined) {
            toast({
                title: 'error',
                description: error.message,
                status: 'error',
                duration: 4000,
                isClosable: true
            });
        }
    }, [data, loading, error]);
    const handleViewBrochureClick = () => {
        if (propertyData?.brochure == "") {
            toast({
                title: 'Brochure not available',
                description: 'The brochure for this property is not available.',
                status: 'warning',
                duration: 4000,
                isClosable: true,
            });
        } else {
            window.location.href = propertyData.brochure;
        }
    };

    const handleClickInterest = async (investmentAmount) => {
        console.log("Interest button clicked", propertyData.id);
        const showInterestInPropertyInput = {
            propertyId: propertyData.id,
            interestSharesIncrement: parseFloat(investmentAmount)
        };
        await showInterestInPropertyMutation({ variables: { showInterestInPropertyInput: showInterestInPropertyInput } });
    }

    return (
        <>

            <Stack minH="55vh" my="70px" align="center" color="#1C3E64" lineHeight="32px"  >
                {loading ? <Spinner color="#0a58ca" size="xl" /> :
                    <Box w="83%" maxW="1300px">
                        <Box mb="60px" p="20px" bgColor="#F0F3FB">
                            <Text textAlign="center" fontSize="13px" fontWeight="600">By expressing interest in this property, we will add your name to our growing list of investors who would like to participate in owning a shares when it becomes available and we are ready to close our offer process. There is no financial obligation until you are notified in advance to secure your allocation.</Text>
                        </Box>
                        <HStack mb="60px" align="center" justify="space-between">
                            <Button border="1px solid #002B5B" _hover={{ color: "#002B5B", bgColor: "white" }} w={{ base: "104px", md: "204px" }} h="50px" fontFamily="Raleway" bgColor="#002B5B" color="white" fontSize={{ base: "13px", md: "20px" }} p="12px 26px">Express Interest</Button>
                            <Button onClick={() => { navigate('/marketplace') }} variant="ghost" fontSize="14px"><ChevronLeftIcon fontSize="24px" /> Go Back to Properties</Button>

                        </HStack>
                        <Flex w="100%" flexDirection={{ base: "column", lg: "row" }}>
                            <Box w={{ base: "100%", lg: "66.6%" }} p={{ lg: "0 70px 0 12px" }} >
                                <Heading fontSize="35px" fontWeight="700">{propertyData?.address} </Heading>
                                <Box mt="35px" mb="40px">
                                    <Link onClick={scrollToSection} _hover={{ textDecoration: "none" }} fontSize="16px" fontWeight="400" p="5px 30px 5px 0" borderRight="0.5px solid #1C3E64">View Documents</Link>
                                    <Link onClick={handleViewBrochureClick} _hover={{ textDecoration: "none" }} fontSize="16px" fontWeight="400" p="5px 30px" borderRight="0.5px solid #1C3E64">View Brochure</Link>
                                    <Link href={propertyData?.mapLocation} _hover={{ textDecoration: "none" }} fontSize="16px" fontWeight="400" p="5px 30px" borderRight="0.5px solid #1C3E64">View on Map</Link>
                                </Box>
                                <PropertyDetailIntro data={propertyData?.images} propertyType={propertyData?.propertyType} propertyClass={propertyData?.propertyClass} documents={propertyData?.documents} />
                                {propertyData?.performanceMetrics && <PerformanceMetrics data={propertyData?.performanceMetrics} />}
                                <Description data={propertyData?.description} />
                                <Divider my="30px" color="#1C3E64" />
                                <InvestmentHighlight data={propertyData?.investmentHighlights} />
                                <ConfidentialReport data={propertyData?.documents} />
                                {/* <InvestmentSnapshot />
                                <TheFarm />
                                <Demographics />
                                <Entertainment />
                                <EventSpaces /> */}
                                <Sponsor data={propertyData?.sponsors} />
                                <Contact data={propertyData?.contactInformation} />
                                <SocialMediaIcn />
                            </Box>
                            <Box w={{ base: "100%", lg: "33.4%" }} p={{ base: "0", lg: "0 12px" }}  >
                                <Heading mb="32px" fontSize="20px" fontWeight="500" textAlign="end">Ticker Symbol: {propertyData?.tickerSymbol}</Heading>
                                <InvestmentCard
                                    handleClickInterest={handleClickInterest}
                                    minimumInvestment={propertyData?.minimumInvestment}
                                    totalShares={propertyData?.totalShares}
                                    investment={investment}
                                    setInvestment={setInvestment}
                                    investmentError={investmentError}
                                    setInvestmentError={setInvestmentError}
                                />

                            </Box>

                        </Flex>


                    </Box>
                }

            </Stack>
            <ProfileFooter />
            <CustomSpinner isSpinnerOpen={showInterestResponse.loading} />

        </>
    );
}

export default PropertyDetail;